import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
} from '@angular/core';

import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'ui-map-link',
  imports: [ButtonComponent],
  templateUrl: './map-link.component.html',
  styleUrl: './map-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapLinkComponent implements OnInit {
  private readonly API_QUERY =
    'https://www.google.com/maps/search/?api=1&query=';
  queryUrl = '';
  latitude = input<number>(0);
  longitude = input<number>(0);
  isButton = input<boolean>(false);
  icon = input<string>('');
  buttonText = input<string>('');

  ngOnInit() {
    this.queryUrl = `${this.API_QUERY}${this.latitude()},${this.longitude()}`;
  }
}
